import { authenticatedFetch } from '../../api/request';

export default function getReceipt(orgId: number, transactionId: string) {
    const url = `/v5/orgs/${orgId}/account/invoices/${transactionId}/receipt`;

    return authenticatedFetch(url);
}
